import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QualityApprovalFilter from './qualityapproval-filter';
import QualityApprovalTable from './qualityapproval-table';
import QualityApprovalTile from './qualityapproval-tile';
import QualityApprovalSearch from './qualityapproval-search';
import { selectQualityApprovalFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const QualityApprovalContent = props => {
  const isFilterVisible = useSelector(selectQualityApprovalFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <QualityApprovalSearch />
        </div>
        {isFilterVisible && <QualityApprovalFilter />}

        {!showTileView ? <QualityApprovalTable /> : <QualityApprovalTile />}
      </div>
    </div>
  );
};

export default QualityApprovalContent;
